/* WebComponentAccordion template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { AccordionComponent } from './cwc-accordion';

/**
 * Definition of  parameters that the template needs to work.
 */
interface AccordionTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: AccordionComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const AccordionTemplate: FunctionalComponent<AccordionTemplateProps> = () => (
  <Host>
    <slot />
  </Host>
);

export default AccordionTemplate;
